import lib from "../lib/lib";

const npl = {
    route: () => {
        // Return the URL Route for posts
        return window.location.protocol + '//' + window.location.hostname + '/wp-json/wp/v2/posts?';
    },
    retrieveCatPost: async (id, index) => {
        // Retrieve Posts based of the Category ID
        state['npl'].origindata[index] = await npl.router(npl.route() + 'categories=' + id + '&filter[orderby]=date&order=asc')
    },
    retrieveSequence: async (state) => {
        // FUNCTION: Runs on Any Page Load, Collects Data
        // Retrieve Categories
        state['npl'].origincat = await npl.router(window.location.protocol + '//' + window.location.hostname + '/wp-json/wp/v2/categories');
    
        // Remove uncategorized category
        state['npl'].filtercat = state.npl.origincat.filter(
            item => item.slug !== 'uncategorized'
        )
        // Fetch Posts from Categories
        await Promise.all(state.npl.filtercat.map(async (cat, index) => {
            await npl.retrieveCatPost(cat.id, index);
        }));
    },
    router: async (url) => {
        try {
            let res = await fetch(url);
            return await res.json();
        } catch(err) {
            // console.log(err);
        }
    },
    setEventListener: () => {
        // FUNCTION: Resets the event listener on Page load

        // Set NPL based on URL
        let params = new URLSearchParams(location.search);

        if(
            params.get('category') == 'developments' ||  
            params.get('category') == 'mixed-use-spaces' ||  
            params.get('category') == 'private-homes') 
        {
            state['npl'].enabled = true;
        } else {
            state['npl'].enabled = false;
        }

        // Add Top Filter Bar Links Event Listener
        lib.qsa('.portfolio-filter').forEach((filter) => {

            state['npl'].i = 0;

            filter.addEventListener('click', function(e) {
                e.preventDefault();

                if(
                    filter.dataset.slug == 'developments' || 
                    filter.dataset.slug == 'mixed-use-spaces' || 
                    filter.dataset.slug == 'private-homes') 
                {
                    state['npl'].enabled = true;
                } else {
                    state['npl'].enabled = false;
                }
            })
        });

        // Add Individual Post Event Listener
        lib.qsa('.portfolio-post').forEach((post) => { 
           
            post.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Run the build sequence IF an ID exists
                npl.buildSequence(post.dataset.pid, post.dataset.catid);
                
            });
        });
    },
    buildSequence: (id, catid) => {
         // FUNCTION: Runs when a page has been clicked on
        if(!id) {
            // console.log('buildSequence: Next Post Logic has no ID'); return;
        }
        if(!catid) {
            // console.log('buildSequence: Next Post Logic has no Category ID'); return;
        }
        if(!state.npl.enabled) {
            // console.log('buildSequence: Next Post Logic is disabled'); return;
        }
        
        // Set the current category Index from Cat ID
        [...state.npl.filtercat].forEach((cat, index) => {
            // console.log(catid)
            if(cat.id == catid) {
                state['npl'].catindex = index;
            }
        });

        // Find current Index from Category Index
        [...state.npl.origindata[ state.npl.catindex ]].forEach((post, index) => {
            if(post.id == id) {
                state['npl'].postindex = index;
            }
        });

        // set up new Filter Data
        state['npl'].filterdata = state.npl.origindata;

        // Re-Order Array Logic
        let previousItems = state.npl.filterdata[state['npl'].catindex].slice(0, state.npl.postindex);
        let currentItem = state.npl.filterdata[state['npl'].catindex][state.npl.postindex];
        let nextItems = state.npl.filterdata[state['npl'].catindex].slice(state.npl.postindex + 1);

        // Filter Data, Select Index and Re-Assign items
        state.npl.filterdata[state.npl.catindex] = [currentItem, ...nextItems, ...previousItems];

        npl.doRender(state);
        
    },
    doRender: (state) => {
        // This function is preparing for render. It'll check values and intercept if needed.
        setTimeout(() => {
            // console.log(state.npl.catindex);
            // console.log(state.npl.filtercat.length);
            if((state.npl.i + 1) == state.npl.filterdata[state.npl.catindex].length) {
                state['npl'].i = -1;
               
                if((state.npl.catindex + 1) == state.npl.filtercat.length ) {
                    state['npl'].catindex = -1;
                }

                state['npl'].catindex++;
            }

            //state['npl'].i++;

            // console.log(state.npl.i);

            npl.render(state.npl.filterdata[state.npl.catindex][state.npl.i + 1]);


            // Re-run function if no render has been detected
            if(!document.querySelector('.next-project-link-block')) {
                npl.doRender(state);
            }
        }, 2000);
    },
    render: (data) => {

        let renderHTML = '';
        let blockWrapper = document.querySelector('.next-project-link-block');
       

        if (data) {
            renderHTML += `<div>`;
                renderHTML += `<div class="image-wrapper">`;
                    renderHTML += `<img class="animate__me" src="${data.acf_thumbnail_img_url.url}" alt="${data.acf_thumbnail_img_url.alt}">`;
                renderHTML += `</div>`;
                renderHTML += `<div class="text-wrapper site-width absolute">`;
                    renderHTML += `<span class="post-category fs-subheading mb-10 md-mb-10 c-secondary">${data.category_name}</span>`;
                    renderHTML += `<span class="post-title fs-60 mb-30 md-mb-30 c-secondary">${data.title.rendered}</span>`;
                    renderHTML += `<div>`;
                        renderHTML += `<a href="${data.link}" class="btn next-link-render">Next project <span data-type="atom" data-temp="atom-icon-slash.twig" class="atom-icon-slash "><svg xmlns="http://www.w3.org/2000/svg" width="13.415" height="15.692" viewBox="0 0 13.415 15.692"><path class="slash-small" id="Black-slash-small" d="M4.97,15.692H0L8.445,0h4.97L4.97,15.692"></path></svg></span></a>`;
                    renderHTML += `</div>`;
                renderHTML += `</div>`;
            renderHTML += `</div>`;

            let html = new DOMParser().parseFromString(renderHTML,"text/html");

            html = html.getRootNode();
            blockWrapper.innerHTML = "";
            blockWrapper.append(html.body);
            
            // Next Project Link Block - On Click Event
            lib.qsa('.next-project-link-block').forEach((elem) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    state.npl.i++;
                    npl.doRender(state);
                });
            });
        }
    }
}

export { npl as default }